import { Injectable, inject } from '@angular/core';

import { MediaConfig, Sitecore, StatisticsConfig } from '@frontend/sports/common/client-config-data-access';
import { ModalDialogService } from '@frontend/sports/modal/feature';
import { DeviceService, Page, WINDOW } from '@frontend/vanilla/core';
import { clamp } from 'lodash-es';

import { BetRadarModalComponent } from './bet-radar-modal.component';

@Injectable({
    providedIn: 'root',
})
export class BetRadarStatisticsService {
    private readonly popupSize = {
        maxHeight: 1080,
        minHeight: 650,
        refHeight: 0.75,
        width: 992,
    };

    constructor(
        private page: Page,
        private device: DeviceService,
        private mediaConfig: MediaConfig,
        private modalDialogService: ModalDialogService,
        private statisticsConfig: StatisticsConfig,
        private sitecore: Sitecore,
    ) {}

    open(betRadarId: number): void {
        if (!this.mediaConfig.showStatsCenterButton) {
            return;
        }

        const url = this.getStatCenterUrl(betRadarId);

        if (this.device.isMobile) {
            this.openMobilePopup(url);
        } else {
            this.openBrowserWindow(url);
        }
    }

    private getStatCenterUrl(betRadarId: number): string {
        let url = this.statisticsConfig.statisticsUrlTemplate;

        url = url.replace('{culture}', this.page.languageCode);
        url = url.replace('{betRadarId}', betRadarId.toString());

        return url;
    }

    private openMobilePopup(url: string): void {
        this.modalDialogService.openDialog(BetRadarModalComponent, {
            settings: {
                cssClass: 'modal-popup bet-radar-popup sports',
                showDialogHeader: true,
                hideCloseButton: false,
                title: this.sitecore.statistics.Statistics,
                isPopup: true,
            },
            data: {
                url,
            },
        });
    }

    private openBrowserWindow(url: string): void {
        const height = clamp(this.#window.innerHeight * this.popupSize.refHeight, this.popupSize.minHeight, this.popupSize.maxHeight);
        const options = `width=${this.popupSize.width},height=${height},menubar=no,toolbar=no,location=no,status=no`;
        const popup = this.#window.open(url, 'statistics', options);
        popup?.focus();
    }

    readonly #window = inject(WINDOW);
}
